<template>
    <b-col cols="12" class="question-container">
        <b-col cols="12" class="mt-2 question">{{label}}<span class="sr-only">.</span></b-col>
        <b-col cols="12" class="answer"><slot></slot><span class="sr-only">.</span></b-col>
    </b-col>
</template>

<script>
    export default {
        name: "BYCQuestion",
        props: ['label']
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"

    .question-container
        padding-right 0
        padding-left 0

    .question
        font font-sourcesans-semibold
        font-size 16px
        letter-spacing 0
        color color-4

    .answer
        font font-sourcesans-regular
        font-size 16px
        letter-spacing 0
        color color-9
        max-height 145px
        overflow-y auto
</style>
